import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "POS Sales by Customer";
const description = `The "POS by Customer" report is a specialized tool within a Point of Sale (POS) system that tracks a customer's purchase history directly at the point of transaction. It provides detailed records of what a customer has bought in the past, including the specific items, the date and time of purchase, and the total amount spent. This report is essential for understanding customer behavior, identifying loyal customers, and enabling businesses to create personalized marketing campaigns and loyalty programs based on a customer's past buying habits.`;

const images = [
    '/images/reports/pos-sales/pos-sales-by-customer/pos-sales-by-customer.png', // 0
];


const PosSalesByCustomer: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PosSalesByCustomer;
